<template>
  <div class="animated fadeIn frm-ubah-harga">
    <b-card>
      <div slot="header">PERUBAHAN HARGA KORAN (PASCA BAYAR)
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
          <b-input-group>
            <b-input-group-append>
              <span class="p-2">Kota</span>
            </b-input-group-append>
              <b-form-input
                v-model="tblData.kota_name" :state="!$v.tblData.jurusan_name.$error"
                @keyup.13.native="lkuKoranKotaShow=true"
                @change="tblData.kota_id=''"
              ></b-form-input>
            <b-input-group-append style="height: 35px;">
              <b-btn text="Button" @click="lkuKoranKotaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
            <b-input-group-append>
              <span class="p-2">Jurusan</span>
            </b-input-group-append>
            <b-form-input
              v-model="tblData.jurusan_name" :state="!$v.tblData.jurusan_name.$error"
              @keyup.13.native="lkuKoranJurusanShow=true" 
              @change="tblData.jurusan_id=''" 
            ></b-form-input>
            <b-input-group-append style="height: 35px;">
              <b-btn text="Button" @click="lkuKoranJurusanShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>            
            <b-input-group-append>
              <span class="p-2">Jenis Kiriman</span>
              </b-input-group-append>
            <b-form-input v-model="tblData.kiriman_name" :state="!$v.tblData.kiriman_name.$error" @change="tblData.kiriman_code=''" placeholder="Jenis Kiriman" ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button" @click="lkuKoranKirimanCodeShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>

                  <b-input-group-append>
                        <b-button variant="success" size="sm" @click="search()" class="ml-1"> <i class="fa fa-refresh"></i> Apply Filter</b-button>                
                  </b-input-group-append>
                  <b-input-group-append>
                        <b-button variant="secondary" size="sm" class="ml-2" @click="clearFilter()" >Clear Filter</b-button>
                  </b-input-group-append>
              </b-input-group>

     <label>AGEN YANG MENGALAMI PERUBAHAN HARGA</label>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
         @row-clicked="rowClicked" 
      >
        <template v-slot:cell(selected)="data">
             <input
            name="selectjurnal"
            type="checkbox"
            @change="checkedjurnal($event,data.item)"
            :data-customer_id="data.item.customer_id"
            :checked="ischeckedjurnal(data.item.customer_id)"
          />
        </template>
        <!-- A custom formatted header cell for field 'name' -->
        <template v-slot:head(selected)="data">
                  <a href="javascript:void(0)" class="text-danger" @click="checkedclear()">
                    <i class="fa fa-eraser"></i>
                  </a>
        </template>        
        <template v-slot:cell(DeliveryAddr)="data">
          <span v-if="(data.item.DeliveryAddr)">{{data.item.DeliveryAddr}}</span>
          <span v-else>
            {{data.item.Address1}}
            {{data.item.Address2}}
          </span>
        </template>
        <template v-slot:cell(hrg_agen_ecer)="data">
          {{uanguser}} &nbsp;&nbsp;{{data.item.hrg_agen_ecer | numFormat}}
        </template>
      </b-table>
      <b-row align-h="between" class="mt-1">
        <b-col lg="5">
            <b-input-group>
                <b-input-group-append>
                    <button  class="btn btn-success" @click="selectall()"><i class="fa fa-check"></i> Select All Customer/Agen</button>
                </b-input-group-append>
                <b-input-group-append>
                    <button class="btn btn-warning ml-1" @click="checkedclear()" > <i class="fa fa-eraser"></i> Clear Selection</button>
                </b-input-group-append>
              <b-input-group-prepend>
              <span class="pt-2">Selected</span>
              <span style="background-color:yellow;" class="p-2"> {{selected.length}} </span>
              <span  class="pt-2">Customer/Agen of {{tblData.total}} records</span>
              </b-input-group-prepend>
            </b-input-group>

        </b-col>
        <b-col lg="6">
            <b-input-group>
              <b-input-group-prepend>
                <span class="p-2">Harga Baru ({{uanguser}})</span>
              </b-input-group-prepend>
              <my-number  class="form-control text-right" separator=","  :precision="2"  v-model="frmdata.hrg_agen_ecer"
                :state="!$v.frmdata.hrg_agen_ecer.$error"></my-number>
              <b-input-group-append><span class="p-2">Berlaku Sejak</span></b-input-group-append>
              <b-form-input v-model="frmdata.tglberlaku" type="date" @change="tanggalBerubah" :state="!$v.frmdata.tglberlaku.$error"></b-form-input>

                <b-input-group-append>
                    <button  class="btn btn-primary ml-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                </b-input-group-append>
                <b-form-checkbox  v-model="inputBerlanjut" :value="1" :unchecked-value="0"  class="pl-2 pt-2"></b-form-checkbox>
                <b-input-group-prepend ><span class="pt-2">remain on Form after save</span></b-input-group-prepend>
            </b-input-group>
        </b-col>
      </b-row>
    </b-card>

    <b-modal v-model="lkuKoranKotaShow" size="lg" :hide-footer="true" title="List Kota" :centered="true">
      <lku-kota @click="onSelectKota"></lku-kota>
    </b-modal>
    <b-modal v-model="lkuKoranJurusanShow" size="lg" :hide-footer="true" title="List Jurusan" :centered="true">
      <lku-jurusan @click="onSelectJurusan"></lku-jurusan>
    </b-modal>
    <b-modal v-model="lkuKoranKirimanCodeShow" size="lg" :hide-footer="true" title="Jenis Kiriman" :centered="true">
      <lku-koranjeniskiriman @click="onSelectKoranJenisKiriman" ></lku-koranjeniskiriman>
    </b-modal>

  </div>
</template>



<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import pesanan_pascabayar from "../../apis/koran_pesanan_pascabayar";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import lkuKota from "../lookup/lkuKoranKota";
import lkuJurusan from "../lookup/lkuKoranJurusan";
import lkuKoranjeniskiriman from "../lookup/lkuKoranJenisKiriman";

toastr.init();

export default {
  components: {Loading,myNumber, lkuKota, lkuJurusan, lkuKoranjeniskiriman},
  mixins: [validationMixin],
  validations: {
    frmdata: {
      hrg_agen_ecer: {
        required: function() {
          if ((this.frmdata.hrg_agen_ecer || 0 )==0) {
            return false;
          } else return true;
        }
      },
      tglberlaku: { required }
    },
    tblData: {
      jurusan_name: {
        required: function() {
          if (this.tblData.jurusan_name) {
            return true;
          } else if ((this.tblData.kota_name) || (this.tblData.kiriman_name)) {
            return true;
          } else return false;
        }
      },
      kota_name: {
        required: function() {
          if (this.tblData.kota_name) {
            return true;
          } else if ((this.tblData.jurusan_name) || (this.tblData.kiriman_name)) {
            return true;
          } else return false;
        }
      },
      kiriman_name: {
        required: function() {
          if (this.tblData.kiriman_name) {
            return true;
          } else if ((this.tblData.kota_name) || (this.tblData.jurusan_name)) {
            return true;
          } else return false;
        }
      },
    }
  },

  data() {
    return {
      pertamakali:true,
      inputBerlanjut: 1,
      lkuKoranKotaShow: false,
      lkuKoranJurusanShow: false,
      lkuKoranKirimanCodeShow: false,
      isLoading:false,
      uanguser: this.$store.state.user.matauang,
      items: [],
      pagination: false,
      limit:15,
      tblData: {
        total: 0,
        sortBy: 'CustName',
        sortDesc: false,
        jurusan_name:'', kota_name:'', kiriman_name:''
      },
    tblFields:[
          {
            key: "selected",
            label: "",
            thStyle: "width:20px",
            thClass:"text-center",
            tdClass:"text-center",
          },
            {
              key: "CustCode",
              label: "Kode",
              thStyle: "width:150px",
              sortable: true
            },
            {
              key: "CustName",
              label: "Nama Agen",
              sortable: true
            },
            {
              key: "kiriman_name",
              label: "Jenis Kiriman",
              sortable: true
            },
            {
              key: "DeliveryAddr",
              label: "Alamat Kirim",
            },
            {
              key: "jurusan_code",
              label: "Rute",
              sortable: true
            },
            {
              key: "kota_name",
              label: "Kota Layanan",
              sortable: true
            },

          {
            key: "hrg_agen_ecer",
            label: "Harga Lama",
            thStyle: "width:100px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
        ],
      model:{},
      frmdata:{hrg_agen_ecer:0, tglberlaku:''},
      hariini:moment().format('YYYY-MM-DD'),
      selected:[],
    };
  },
  computed: {
    invalidModel() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
    invalidFilter() {
      this.$v.tblData.$touch();
      return this.$v.tblData.$invalid;
    },
  },

  watch:{
    limit: function (newVal){
      setTimeout(() => {
        if (this.limit==newVal) {
          this.tblData.limit=newVal;
        }
      }, 500);
    },    
  },
  created: async function(){
    this.frmdata.tglberlaku=this.hariini;
        // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.tblData.tgl1=this.$store.state.user.tglaktif;
        // this.tblData.tgl2=tgl2.format('YYYY-MM-DD');
  },  
  methods: {
    onSelectKota: function(_selected) {
      this.tblData.kota_id = _selected.kota_id;
      this.tblData.kota_name = _selected.kota_name;
      this.lkuKoranKotaShow = false;
    },
    onSelectJurusan: function(_selected) {
      this.tblData.jurusan_id = _selected.jurusan_id;
      this.tblData.jurusan_name = _selected.jurusan_name;
      this.lkuKoranJurusanShow = false;
    },
    onSelectKoranJenisKiriman: function(_selected) {
      this.tblData.kiriman_name = _selected.kiriman_name;
      this.tblData.kiriman_code = _selected.kiriman_code;
      this.lkuKoranKirimanCodeShow = false;
    },
    tanggalBerubah: function(){
            const newval=moment(this.frmdata.tglberlaku).format('YYYY-MM-DD');
            if ( this.hariini < newval) {
              this.frmdata.tglberlaku=this.hariini;
              toastr.error('Tanggal BERLAKU SEJAK tidak boleh lebih dari hari ini','ERROR MESSAGE',10000);
            }
    },

    ischeckedjurnal(val){
      const findjv = this.selected.find(x => x === val);
      if(findjv){
        return 'checked'
      }else{
        return '';
      }
    },
    checkedclear() {
      this.selected = [];
      const checkBoxes = document.querySelectorAll('[name="selectjurnal"]') || [];
      checkBoxes.forEach(element => {
        element.checked= false;
      });
    },
    selectall() {
      if (this.items.length==0) {
          toastr.error('Daftar Customer/Agen masih kosong','ERROR MESSAGE',10000);
      } else {
        this.selected=[];
        this.items.forEach(element => {
            this.selected.push(element.customer_id);    
            console.log(this.selected);      
        });
      }
      this.$forceUpdate();
      this.$v.frmdata.$touch();
    },

    checkedjurnal(item,record) {
      this.rowClicked(record);
      const customer_id = item.target.attributes["data-customer_id"].value;
      if (item.target.checked) {
        const findjv = this.selected.find(x => x === customer_id);
        if (!(findjv)){
          this.selected.push(customer_id);
        }
      } else {
        const findIdx = this.selected.findIndex(x => x === customer_id);
        this.selected.splice(findIdx, 1);
      }
    },
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function() {
        if (this.pertamakali==true){
          this.$v.tblData.$touch();
          setTimeout(() => {
              this.pertamakali=false;
          }, 500);
        } else {
          if (this.invalidFilter) {
            this.isLoading = false;
              const invalidobj={};
              for (var key in this.$v.tblData) {
                if (this.$v.tblData[key].$anyError) {
                  if (this.$v.tblData[key].$anyError==true) invalidobj[key] = this.$v.tblData[key];
                }
              }        
              console.log('validation tblData: ', this.$v.tblData);
              console.log('validation field: ', invalidobj);
            toastr.error("Filter Harus diisi!", "ERROR MESSAGE");
          } else {
                this.pagination=false;
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await pesanan_pascabayar.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }    
          }        
        }
  },
    refresh() {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    search() {
      this.tblData.page=1;
      this.selected=[];
      this.refresh();
    },
    clearFilter() {
      this.tblData.kota_id = '';
      this.tblData.kota_name = '';
      this.tblData.area_id = '';
      this.tblData.area_name = '';
      this.tblData.jurusan_id = '';
      this.tblData.jurusan_name = '';
      this.tblData.kiriman_code = '';
      this.tblData.kiriman_name = '';
      this.selected=[];

    },
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    save: async function() {
      this.isLoading = true;
      if (this.invalidModel) {
        this.isLoading = false;
          const invalidobj={};
          for (var key in this.$v.frmdata) {
            if (this.$v.frmdata[key].$anyError) {
              if (this.$v.frmdata[key].$anyError==true) invalidobj[key] = this.$v.frmdata[key];
            }
          }        
          console.log('validation frmdata: ', this.$v.frmdata);
          console.log('validation field: ', invalidobj);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else if (this.selected.length==0) {
        toastr.error("AGEN YANG MENGALAMI PERUBAHAN HARGA belum dipilih", "ERROR MESSAGE");
      } else {
        try {
          const data={hrg_agen_ecer: this.frmdata.hrg_agen_ecer};
          data.tglberlaku = moment(this.frmdata.tglberlaku).format('YYYY-MM-DD');
          data.lines=this.selected;
          await pesanan_pascabayar.ubahharga(data);
          toastr.success("Save successfully");
          this.isLoading = false;
          if (this.inputBerlanjut==1) {
              this.refresh();
          } else {
            this.close();
          }
        } catch (error) {
                this.isLoading=false;
                console.log('error : ', error);
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
                } else {
                    toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                }   
        }
      }
    },

    close(){
      router.push({name: "koran.home"});
    },    
  }
};
</script>
